module.exports = __webpack_public_path__ + "static/media/com-icon.525c06cd.svg";